// import page
import PrivateRouter from '../PrivateRouter';
import Layout from 'pages/Admin/ui/Layout';

import AdminComponent from 'pages/Admin/pages';

//** Required */
export const PATH = {
  // Do not start with '/' due to it is relative path
  dashboard: 'dashboard',
  userProfile: 'userProfile',
  firmware: 'firmware',
  operatorManagement: 'operatorManagement',
  uidLookup: 'uidLookup',
  mspNoticeEditor: 'mspNoticeEditor',
  rmaDelete: 'rmaDelete',
  changeLog: 'changeLog',
  noticeEditor: 'noticeEditor',
  settings: {
  }
};

//** Required */
export const cloudAdminRouteList = [
  {
    title: 'Firmware Management',
    path: PATH.firmware,
    element: <AdminComponent.OBUFirmware
      PathList={[
        { label: 'Firmware Management' },
      ]}
      title={'Firmware Management'}
    />,
  },
  {
    title: 'Operator Management',
    path: PATH.operatorManagement,
    element: <AdminComponent.OBUOperatorManagement
      PathList={[
        { label: 'Operator Management' },
      ]}
      title={'Operator Management'}
    />,
  },
  {
    title: 'UID Lookup',
    path: [PATH.dashboard, PATH.uidLookup],
    element: <AdminComponent.OBUUidLookup
      PathList={[
        { label: 'UID Lookup' },
      ]}
      title={'UID Lookup'}
    />,
  },
  {
    title: 'MSP Notice Editor',
    path: PATH.mspNoticeEditor,
    element: <AdminComponent.OBUMspNoticeEditor
      PathList={[
        { label: 'MSP Notice Editor' },
      ]}
      title={'MSP Notice Editor'}
    />,
  },
  {
    title: 'RMA Delete',
    path: PATH.rmaDelete,
    element: <AdminComponent.OBURmaDelete
      PathList={[
        { label: 'RMA Delete' },
      ]}
      title={'RMA Delete'}
    />,
  },
  {
    title: 'Change Log',
    path: PATH.changeLog,
    element: <AdminComponent.OBUChangeLog
      PathList={[
        { label: 'Change Log' },
      ]}
      title={'Change Log'}
    />,
  },
  {
    title: 'Notice Editor',
    path: PATH.noticeEditor,
    element: <AdminComponent.OBUNoticeEditor
      PathList={[
        { label: 'Notice Editor' },
      ]}
      title={'Notice Editor'}
    />,
  },
  {
    path: PATH.userProfile,
    element: <AdminComponent.OBUUserProfile
      PathList={[
        { label: 'User Profile' },
      ]}
      title={'User Profile'}
    />,
    isNavigator: false,
  },
];

export const adminRootElement = {
  path: "/admin",
  element: <PrivateRouter><Layout /></ PrivateRouter>,
  children: [],
};